import GridLayout from "react-grid-layout";
import {useWindowSize} from "../../hooks/common/useWindowSize";
import {DraggableItem} from "../../styles/dashboard";
import {useLayoutContext} from "../../contexts/layout";
import {layoutComps} from "../../constants/layouts";
import {loadPersistedData} from "../../utils/persistor";
import {useEffect, useState} from "react";
import Tour from "../../packages/tour/Tour";
import {useTradePrice} from "../../contexts/trade-price";
import {useMainContext} from "../../contexts/main";
import {tourOptions} from "../../constants/tour";


const Desktop = () => {

    const { main: {lang} } = useMainContext()
    const { width } = useWindowSize()
    const { layout, activeLayout } = useLayoutContext()
    const [isFullscreen, setIsFullscreen] = useState()
    const { setActiveSpotTab } = useTradePrice()

    useEffect(() => {
        setIsFullscreen(loadPersistedData('fullscreen')?.includes(activeLayout))
    }, [activeLayout])

    return (
        <Tour options={tourOptions(lang, setActiveSpotTab)}>
            <div style={{
                maxWidth: isFullscreen ? width : '1500px',
                direction: 'ltr', margin: '0 auto'
            }}>
                <GridLayout
                    className="layout"
                    layout={layout}
                    cols={24}
                    rowHeight={10}
                    width={isFullscreen ? width : (
                        width < 1500 ? width : 1500
                    )}
                    margin={[0, 0]}
                    isDraggable={false}
                    isResizable={false}
                >
                    {layout?.map(item => {
                        const Pane = layoutComps[item.i]
                        return (
                            <div key={item.i} style={{ zIndex: item.zIndex || 101 }}>
                                <DraggableItem
                                    item={item.i}
                                    id={item.i}
                                >
                                    <Pane />
                                </DraggableItem>
                            </div>
                        )
                    })}
                </GridLayout>
            </div>
        </Tour>
    )
}



export default Desktop
